import { useState } from "react";
import { faqs } from "@/mocks/content";

export default function Faq() {
  const [openId, setOpenId] = useState<string | null>(faqs[0]?.id ?? null);

  return (
    <section id="faq" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8">
        <div className="max-w-3xl">
          <span className="text-xs md:text-sm font-label font-medium tracking-widest text-accent-700 uppercase">
            FAQ
          </span>
          <h2 className="mt-3 font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-snug">
            常见问题
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700 font-body">
            关于系列结构、观看顺序与页面使用方式，下面这些是被问得最多的问题。
            点击任一问题即可展开查看答案。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-4">
          {faqs.map((item) => {
            const isOpen = openId === item.id;
            return (
              <div
                key={item.id}
                className="rounded-lg bg-background-100 border border-background-200/70 overflow-hidden self-start"
              >
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpenId(isOpen ? null : item.id)}
                    aria-expanded={isOpen}
                    className="w-full flex items-start justify-between gap-4 px-5 py-4 text-left cursor-pointer hover:bg-background-200/40 transition-colors"
                  >
                    <span className="font-heading font-semibold text-sm md:text-base text-foreground-950 leading-snug">
                      {item.question}
                    </span>
                    <span
                      className={`w-7 h-7 shrink-0 flex items-center justify-center rounded-full bg-background-50 text-foreground-700 transition-transform duration-300 ${
                        isOpen ? "rotate-45" : ""
                      }`}
                    >
                      <i className="ri-add-line"></i>
                    </span>
                  </button>
                </h3>
                {isOpen && (
                  <div className="px-5 pb-5 -mt-1">
                    <p className="text-sm leading-relaxed text-foreground-700 font-body border-t border-background-200/70 pt-4">
                      {item.answer}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}